const units = ['B', 'KB', 'MB', 'GB', 'TB'];

/** 1536 → "1.5 KB". */
export function bytes(n: number): string {
  let i = 0;
  let v = n;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${i === 0 ? v : v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
}

const when = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });

export function date(iso: string): string {
  return when.format(new Date(iso));
}

/** What the preview can show, by content type. */
export function previewKind(contentType: string): 'video' | 'image' | 'pdf' | 'audio' | null {
  if (contentType.startsWith('video/')) return 'video';
  if (contentType.startsWith('image/')) return 'image';
  if (contentType.startsWith('audio/')) return 'audio';
  if (contentType === 'application/pdf') return 'pdf';
  return null;
}
